// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__26MlR","inner":"Footer_inner__Nj2l2"};